import { GoogleOrganizationData } from 'types/GoogleOrganizationData'

export const getGoogleOrganizationData: GoogleOrganizationData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  legalName: 'Once Upon | Photo Books',
  url: 'https://onceupon.photo/',
  contactPoint: {
    '@type': 'ContactPoint',
    url: 'https://onceupon.photo/help/support',
    contactType: 'customer service',
  },
  logo: 'https://lh3.googleusercontent.com/w7qdam9HeRSVROL3GhQ_THMV6_FDUA5RGmzY-rVbBvbw--hhmvZAeWEmPuSwNFVVQbnNw99yCV2PLgdw=s0',
  sameAs: [
    'https://www.facebook.com/onceuponpublishing/',
    'https://www.linkedin.com/company/onceuponpublishingab',
    'https://www.pinterest.com/onceuponpublishing/',
    'https://www.instagram.com/onceuponapp/',
    'https://www.youtube.com/channel/UCA1g4huEi4HrcE48lhbkFkA',
  ],
}
